import React from 'react'

const VimeoIcon = () => (
    <svg width="29px" height="30px" viewBox="0 0 29 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Nav-Update" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="00-IntroScreen_loggedIn" transform="translate(-995.000000, -612.000000)">
                <g id="vimeo_icon" transform="translate(995.000000, 612.000000)">
                    <rect
                        id="Rectangle-5"
                        fill="#1AB7EA"
                        x="0"
                        y="0"
                        width="28.8074449"
                        height="30"
                        rx="14.4037224"
                    ></rect>
                    <path
                        d="M18.7290519,18.3449702 C16.553729,21.097027 14.7130997,22.4736842 13.2080862,22.4736842 C12.2750406,22.4736842 11.4859095,21.6359767 10.8410619,19.9593042 C10.41061,18.4223993 9.9805271,16.885674 9.54989068,15.3487691 C9.07091374,13.6729948 8.55761874,12.8342094 8.00816061,12.8342094 C7.88841638,12.8342094 7.46958832,13.0794315 6.75241446,13.56772 L6,12.6238394 C6.78968462,11.9485354 7.5684834,11.2730518 8.33473579,10.5966699 C9.38789463,9.71099588 10.1790553,9.24480438 10.7060037,9.19791576 C11.9506795,9.08132297 12.7171164,9.90986832 13.0047609,11.6835518 C13.3156531,13.5975419 13.5309713,14.7877225 13.6516381,15.2535547 C14.0110553,16.8414801 14.4060821,17.6346345 14.837272,17.6346345 C15.171781,17.6346345 15.6751126,17.1197578 16.3459756,16.089286 C17.0155469,15.0595328 17.3745951,14.2758999 17.4229356,13.7373095 C17.5186941,12.8485814 17.1596459,12.4030497 16.3459756,12.4030497 C15.9629416,12.4030497 15.5679148,12.4889223 15.1616331,12.6585118 C15.9481812,10.1511381 17.450427,8.93329145 19.6678171,9.00281596 C21.3117634,9.04970459 22.0872411,10.0877217 21.9922206,12.1168674 C21.9210014,13.6332922 20.83334,15.7093265 18.7290519,18.3449702 Z"
                        id="Fill-4"
                        fill="#FFFFFE"
                    ></path>
                </g>
            </g>
        </g>
    </svg>
)

export default VimeoIcon
